<template>
  <div class="home">
    <div class="banner outer">
      <div class="inside banner__text">
        <div class="fl text__text">
          <h1>易猎云招聘管理系统</h1>
          <p>
            易猎云招聘管理系统是一款专注于批量招聘人效提升的RPO工作平台，主要帮助RPO企业解决批量招聘的效率、管理、渠道以及内部协同等问题，RPO小微企业永久免费。
          </p>
        </div>
        <div class="fr text__img">
          <img
            src="https://images.36w.cn/ylyofficialWebImagse/home_banner.jpg"
          />
        </div>
      </div>
      <div class="tabbar">
        <div class="tabbox">
          <p class="tbtext">提升招聘效率</p>
          <p class="tbnumber">62%</p>
        </div>
        <div class="tabbox">
          <p class="tbtext">提升管理效率</p>
          <p class="tbnumber">151%</p>
        </div>
        <div class="tabbox">
          <p class="tbtext">降低成本</p>
          <p class="tbnumber">39%</p>
        </div>
      </div>
    </div>
    <div class="platform outer">
      <div class="inside">
        <h2>专注人效提升的RPO工作平台</h2>
        <p>
          易猎云团队针对RPO企业在批量招聘过程中的痛点，提供从手工操作到线上系统数字化所需的招聘渠道打通，人才库管理，自动拨号等解决方案，提升企业的招聘效率。
        </p>
        <div class="platform__img">
          <img
            class="img100"
            src="https://img.yilieyun.com/front-yilieyun/official/working-chahua.png"
          />
        </div>
      </div>
    </div>
    <div class="digitalizebox outer">
      <div class="inside">
        <h2>招聘全流程数字化</h2>
        <p style="margin-top:39px">打通主流招聘平台，微信及外呼等行为，招聘顾问的工作行为全流程数字化，</p>
        <p>帮助员工提升工作效率，优化行为规范，为管理者决策提供帮助。</p>
        <div class="platform__img">
          <img
            class="img100"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/Hero%20Image%402x.png"
          />
        </div>
      </div>
    </div>
    <div class="solution outer">
      <div class="inside">
        <h2>专业的RPO批量招聘管理系统解决方案</h2>
        <p class="bigtitle">易猎云对小微RPO企业永久免费，真正的免费招聘管理系统</p>
        <div class="solutiondownbox">
          <div class="solutionleft fl">
            <p class="sotitle">特色功能</p>
            <ul class="sotlist">
              <li class="sotlistchild">
                <img
                  class="fl"
                  src="https://images.36w.cn/ylyofficialWebImagse/icon_triangle@2x.png"
                />
                <span>招聘平台整合及职位投放分析</span>
              </li>
              <li class="sotlistchild">
                <img
                  class="fl"
                  src="https://images.36w.cn/ylyofficialWebImagse/icon_triangle@2x.png"
                />
                <span>简历入库，查重，分配及使用分析</span>
              </li>
              <li class="sotlistchild">
                <img
                  class="fl"
                  src="https://images.36w.cn/ylyofficialWebImagse/icon_triangle@2x.png"
                />
                <span>人才库管理、激活及复用</span>
              </li>
              <li class="sotlistchild">
                <img
                  class="fl"
                  src="https://images.36w.cn/ylyofficialWebImagse/icon_triangle@2x.png"
                />
                <span>多维度报表分析及行为管理</span>
              </li>
            </ul>
          </div>
          <div class="solutionright fr">
            <img
              src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/yilieyun_picture%402x.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="process outer" style="display: none">
      <div class="inside">
        <h2>招聘全流程数字化管理</h2>
        <div class="serviceProcessChart">
          <ul class="cl">
            <li v-for="(yu, index) in serviceProcessChartList" :key="index">
              <h3><img :src="yu.serviceProcessChartimg" /></h3>
              <p>{{ yu.serviceProcessCharttext }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="advantage outer">
      <div class="inside">
        <h2>易猎云产品优势</h2>
        <div class="advantage__box">
          <div class="advobx__child">
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/icon_grasp the deepening@2x.png"
            />
            <h4>领域深耕</h4>
            <p>
              管理团队来自华为、字节跳动、阿里巴巴、智联招聘等行业头部公司，具备10年以上的行业纵深经验。
            </p>
          </div>
          <div class="advobx__child">
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/icon_technical advantage@2x.png"
            />
            <h4>技术优势</h4>
            <p>
              团队成员大部分来自BAT等一线互联网公司及智联招聘、北森等人力资源公司，拥有丰富的互联网开发及管理经验。
            </p>
          </div>
          <div class="advobx__child">
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/icon_advantage of service@2x.png"
            />
            <h4>服务优势</h4>
            <p>
              专属的客户成功团队，保障每一家客户在使用过程中遇到的问题都能第一时间跟进及解决，保障客户真正的成功。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="excellent outer">
      <div class="inside">
        <h2>与更多优秀企业共同成长</h2>
        <div class="exec__list">
          <div class="exec__list__one">
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/logo1@2x.png"
            />
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/logo2@2x.png"
            />
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/logo3@2x.png"
            />
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/logo4@2x.png"
            />
          </div>
          <div class="exec__list__two">
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/logo5@2x.png"
            />
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/logo6@2x.png"
            />
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/logo7@2x.png"
            />
            <img
              src="https://images.36w.cn/ylyofficialWebImagse/logo8@2x.png"
            />
          </div>
          <div class="exec__list__two">
            <img
              class="exceimg1"
              src="https://img.yilieyun.com/front-yilieyun/official/logo9@2x.png"
            />
            <img
              class="exceimg1"
              src="https://img.yilieyun.com/front-yilieyun/official/logo10@2x.png"
            />
            <img
              src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/logo9%402x.png"
            />
            <img
              src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/logo10%402x.png"
            />
          </div>
          <div class="exec__list__three">
            <img
              class="exceimg2"
              src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/logo11%402x.png"
            />
            <img
              class="exceimg2"
              src="https://img.yilieyun.com/front-yilieyun/official/logo11@2x.png"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="digitization">
      <h2>即刻开启数字化招聘人效提升之旅</h2>
      <div @click="trial" class="btnclick">免费开通</div>
    </div>
    <div class="partner outer">
      <div class="inside">
        <h2>合作伙伴</h2>
        <div class="partner__list">
          <div class="parchild">
            <img
              class="img1"
              src="https://img.yilieyun.com/front-yilieyun/official/icon_zhilianzhaopin@2x.png"
            />
          </div>
          <div class="parchild">
            <img
              class="img2"
              src="https://images.36w.cn/ylyofficialWebImagse/icon_qianchenwuyou@2x.png"
            />
          </div>

          <div class="parchild">
            <img
              class="img3"
              src="https://img.yilieyun.com/front-yilieyun/official/icon_boss@2x.png"
            />
          </div>
          <div class="parchild">
            <img
              class="img4"
              src="https://images.36w.cn/ylyofficialWebImagse/icon_58@2x.png"
            />
          </div>
        </div>
      </div>
    </div>

    <!--申请试用组件-->
    <populone :isshow="windowflag" :he="true" @handleChange="changewindow" />

    <!--    <el-dialog-->
    <!--      :visible.sync="dialogVisiblesss"-->
    <!--      class="diawarp"-->
    <!--      :show-close="false"-->
    <!--      :close-on-click-modal="false"-->
    <!--      custom-class="ssssssss"-->
    <!--      width="750px">-->
    <!--      <div class="baei">-->
    <!--            <img class="baei_img"-->
    <!--                 @click="dialogVisiblesss = false"-->
    <!--                 src="../../../assets/img/icon_Close-2@2x.png" alt="">-->
    <!--            <img class="baei_img_con"-->
    <!--                 src="../../../assets/img/B48D1BE9-9976-4E66-9805-34C4FEE6E3AF.png">-->
    <!--      </div>-->
    <!--      <span slot="footer" class="dialog-footer">-->
    <!--        <div>-->
    <!--                  <div @click="lijitiyan">-->
    <!--                    <img src="../../../assets/img/pic_yellow_bg@2x.png"-->
    <!--                         @click="lijitiyan" alt="">-->
    <!--                    <p @click="lijitiyan">立即体验</p>-->
    <!--                  </div>-->
    <!--            </div>-->
    <!--          </span>-->
    <!--    </el-dialog>-->

    <!-- <div class="mask" v-if="dialogVisiblesss"></div>
    <div class="warpDia" v-if="dialogVisiblesss">
      <div class="warpDia_one">
        <img
          class="baei_img"
          @click="dialogVisiblesss = false"
          src="../../../assets/img/icon_Close-2@2x.png"
          alt=""
        />
      </div>
      <div class="warpDia_two">
        <img
          class="baei_img_con"
          src="https://img.yilieyun.com/front-yilieyun/official/forever-free.png"
        />
      </div>
      <div class="warpDia_three">
        <div @click="lijitiyan" class="warpDia_three_s">
          <img
            src="../../../assets/img/pic_yellow_bg@2x.png"
            @click="lijitiyan"
            alt=""
          />
          <p @click="lijitiyan">立即体验</p>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import populone from "@/components/views/popul/populone.vue";

export default {
  name: "home",
  data() {
    return {
      routeData:{},
      dialogVisiblesss: true,
      windowflag: false,
      serviceProcessChartList: [
        {
          serviceProcessCharttext: "岗位投放",
          serviceProcessChartimg:
            "https://images.36w.cn/ylyofficialWebImagse/icon_recruit_01@2x.png",
        },
        {
          serviceProcessCharttext: "简历入库",
          serviceProcessChartimg:
            "https://images.36w.cn/ylyofficialWebImagse/icon_recruit_02@2x.png",
        },
        {
          serviceProcessCharttext: "人岗匹配",
          serviceProcessChartimg:
            "https://images.36w.cn/ylyofficialWebImagse/icon_recruit_03@2x.png",
        },
        {
          serviceProcessCharttext: "邀约",
          serviceProcessChartimg:
            "https://images.36w.cn/ylyofficialWebImagse/icon_recruit_04@2x.png",
        },
        {
          serviceProcessCharttext: "面试",
          serviceProcessChartimg:
            "https://images.36w.cn/ylyofficialWebImagse/icon_recruit_05@2x.png",
        },
        {
          serviceProcessCharttext: "Offer",
          serviceProcessChartimg:
            "https://images.36w.cn/ylyofficialWebImagse/icon_recruit_06@2x.png",
        },
        {
          serviceProcessCharttext: "入职",
          serviceProcessChartimg:
            "https://images.36w.cn/ylyofficialWebImagse/icon_recruit_07@2x.png",
        },
      ],
    };
  },
  metaInfo: {
    title: "易猎云招聘管理系统-RPO工作平台-小微企业免费",
    meta: [
      {
        name: "keywords",
        content: "易猎云，招聘管理系统，RPO，批量招聘，免费",
      },
      {
        name: "description",
        content: "易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统",
      },
    ],
  },
  components: {
    populone,
  },
  mounted(){
    console.log("官网-加载");
  if (Object.keys(this.$route.query).length) {
      this.routeData = this.$route.query;
    }
    const { u = "" } = this.routeData;
    if (!u) {
      console.log("官网加载");
      zhuge.track("官网加载", {
        渠道: "pc",
        utm类型: "自然流量",
      });
    } else {
      zhuge.track("官网加载", {
        渠道: "pc",
        utm类型: "驱动流量",
      });
    }
  },
  methods: {
    trial() {
      this.windowflag = true;
    },
    lijitiyan() {
      this.dialogVisiblesss = false;
      this.$nextTick(() => {
        // let box = document.getElementById("v-modal");
        // box.remove();
        this.windowflag = true;
      });
    },
    changewindow(value) {
      this.windowflag = value;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";

.diawarp {
  /deep/ .el-dialog__header {
    height: 50px;
    background: #215fff;
  }

  /deep/ .el-dialog__body {
    background: #215fff;
    padding: 0;

    .baei {
      width: 100%;
      height: 470px;
      background: url("../../../assets/img/pic_blue_bg@2x.png");
      position: relative;

      .baei_img {
        position: absolute;
        right: 20px;
        top: -20px;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }

      .baei_img_con {
        width: calc(100% + 2px);
        position: relative;
        left: -2px;
        height: 100%;
      }
    }
  }

  /deep/ .el-dialog__footer {
    height: 100px;
    background: #215fff;

    .dialog-footer {
      display: flex;

      & > div {
        margin: auto;
        width: 300px;
        height: 60px;

        div {
          width: 100%;
          height: 100%;
          position: relative;

          img {
            width: 100%;
            height: 100%;
            position: relative;
            bottom: -10px;
            cursor: pointer;
          }

          p {
            position: absolute;
            left: 110px;
            top: 30px;
            font-size: 22px;
            color: #9e2b00;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.home {
  margin-top: 105px;

  .banner {
    position: relative;
    width: 100%;
    height: 709px;
    background: #e7f2ff;

    .banner__text {
      .text__text {
        width: 632px;
        height: 705px;

        h1 {
          font-size: 70px;
          color: #1d2754;
          margin-top: 200px;
        }

        p {
          font-size: 18px;
          color: #3a4d70;
          line-height: 30px;
          margin-top: 44px;
          text-indent: 2em;
          text-align: justify;
        }
      }

      .text__img {
        width: 564px;
        height: 705px;
        padding-left: 43px;

        img {
          width: 500px;
          height: 412px;
          margin-top: 65px;
        }
      }
    }

    .tabbar {
      display: flex;
      position: absolute;
      width: 1200px;
      height: 180px;
      left: 50%;
      transform: translateX(-50%);
      top: 606px;
      border-radius: 102px;
      border: 1px solid #c7d6fc;
      background: #ffffff;

      .tabbox {
        flex: 1;

        .tbtext {
          font-size: 24px;
          font-weight: 600;
          color: #1d2754;
          text-align: center;
          margin-top: 46px;
        }

        .tbnumber {
          font-size: 50px;
          font-weight: 600;
          color: #fb983c;
          line-height: 70px;
          margin-top: 10px;
          text-align: center;
        }
      }
    }
  }

  .platform {
    width: 100%;
    height: 956px;
    background: #ffffff;
    padding-top: 157px;

    h2 {
      font-size: 52px;
      font-weight: 500;
      color: #1d2754;
      text-align: center;
    }

    p {
      font-size: 18px;
      width: 715px;
      margin: 0 auto;
      font-weight: 500;
      color: #1d2754;
      line-height: 30px;
      margin-top: 64px;
    }

    .platform__img {
      width: 615px;
      height: 464px;
      margin: 0 auto;
      margin-top: 45px;
    }
  }
  .digitalizebox{
    width: 100%;
    height: 700px;
    background: #EFF6FF;
    padding-top: 92px;
    box-sizing: border-box;
    h2 {
      font-size: 52px;
      color: #1D2754;
      text-align: center;
      line-height: 84px;
      font-weight: 500;
    }
    p{
      text-align: center;
      font-size: 18px;
      color: #1D2754;
      line-height: 30px;
      font-weight: 500;
    }
    .platform__img {
      width: 405px;
      height: 294px;
      margin: 0 auto;
      margin-top: 45px;
    }
  }
  .solution {
    width: 100%;
    height: 842px;
    background-image: url("https://images.36w.cn/ylyofficialWebImagse/bg_blue@2x.png");
    background-repeat: no-repeat;
    background-size: 103%;
    padding-top: 100px;

    h2 {
      font-size: 52px;
      color: #ffffff;
      text-align: center;
      line-height: 84px;
    }

    .bigtitle {
      font-size: 28px;
      color: #ffffff;
      line-height: 40px;
      text-align: center !important;
      margin-top: 24px;
    }

    .solutiondownbox {
      width: 100%;
      height: 448px;
      margin-top: 53px;

      .solutionleft {
        width: 535px;

        .sotitle {
          font-size: 36px;
          color: #ffffff;
          margin-top: 43px;
          margin-left: 61px;
        }

        .sotlist {
          margin-top: 37px;
          margin-left: 61px;

          .sotlistchild {
            height: 30px;
            margin-top: 23px;
            position: relative;

            img {
              position: absolute;
              width: 12px;
              height: 18px;
              top: 1px;
            }

            span {
              position: absolute;
              font-size: 24px;
              color: #ffffff;
              left: 20px;
            }
          }
        }
      }

      .solutionright {
        img {
          width: 646px;
          height: 448px;
        }
      }
    }
  }

  .process {
    width: 100%;
    height: 611px;
    background: #eff6ff;
    padding-top: 132px;

    h2 {
      font-size: 40px;
      color: #1d2754;
      line-height: 56px;
      text-align: center;
    }

    .serviceProcessChart {
      ul {
        padding-top: 71px;
        width: 1240px;

        li {
          width: 140px;
          height: 210px;
          background-color: #ffffff;
          border-radius: 10px;
          float: left;
          margin-right: 37px;
          position: relative;

          h3 {
            width: 65px;
            height: 65px;
            background-color: #f8fafe;
            border: solid 1px #e6edff;
            margin: 0 auto;
            margin-top: 33px;
            border-radius: 50%;

            img {
              width: 100%;
              height: 100%;
            }
          }

          p {
            text-align: center;
            margin-top: 38px;
            font-size: 18px;
            line-height: 29px;
            height: 29px;
            letter-spacing: -1px;
            font-weight: 600;
            color: #1d2754;
            line-height: 29px;
          }
        }

        li:after {
          content: "";
          position: absolute;
          display: inline-block;
          width: 37px;
          height: 19px;
          background-image: url("https://images.36w.cn/officialWebImagse/icon_right_arrow@3x.png");
          background-size: 100%;
          right: -37px;
          top: 50%;
          transform: translateY(-50%);
        }

        li:last-child:after {
          content: "";
          width: 0;
          height: 0;
          border: 0;
        }
      }
    }
  }

  .advantage {
    width: 100%;
    height: 636px;
    background: #ffffff;
    padding-top: 98px;

    h2 {
      font-size: 52px;
      color: #1d2754;
      line-height: 44px;
      text-align: center;
      font-weight: 500;
    }

    .advantage__box {
      display: flex;
      width: 100%;
      height: 397px;
      margin-top: 90px;

      .advobx__child {
        flex: 1;

        img {
          width: 155px;
          height: 155px;
          margin: 0 auto;
        }

        h4 {
          font-size: 22px;
          color: #1d2754;
          margin-top: 22px;
          text-align: center;
        }

        p {
          width: 284px;
          font-size: 16px;
          color: #1d2754;
          line-height: 25px;
          margin: 0 auto;
          margin-top: 19px;
          text-align: justify;
        }
      }
    }
  }

  .excellent {
    width: 100%;
    height: 900px;
    background-image: url("https://img.yilieyun.com/front-yilieyun/official/big-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 102%;
    padding-top: 88px;

    h2 {
      font-size: 52px;
      font-weight: 500;
      color: #1d2754;
      line-height: 44px;
      text-align: center;
    }

    .exec__list {
      width: 100%;
      height: 600px;
      background: #ffffff;
      margin-top: 81px;
      padding-top: 66px;

      .exec__list__one {
        display: flex;
        width: 100%;
        height: 85px;
        padding-left: 30px;
        padding-right: 50px;

        img {
          flex: 1;
          width: 260px;
          height: 85px;
          justify-content: space-between;
          margin-left: 20px;
        }
      }

      .exec__list__two {
        display: flex;
        width: 100%;
        height: 85px;
        margin-top: 50px;
        padding-left: 30px;
        padding-right: 50px;

        img {
          flex: 1;
          width: 260px;
          height: 85px;
          justify-content: space-between;
          margin-left: 20px;
        }
      }

      .exec__list__three {
        display: flex;
        width: 100%;
        height: 85px;
        margin-top: 50px;
        padding-left: 30px;
        padding-right: 50px;

        .exceimg1 {
          flex: 1;
          height: 85px;
          justify-content: space-between;
          margin-left: 20px;
        }

        .exceimg2 {
          flex: 2.1;
          width: 520px;
          height: 85px;
          justify-content: space-between;
          margin-left: 20px;
        }
      }
    }
  }

  .digitization {
    position: relative;
    width: 100%;
    height: 575px;
    background-image: url("https://img.yilieyun.com/front-yilieyun/official/bottom-banner.png");
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 232px;

    h2 {
      font-size: 50px;
      color: #ffffff;
      text-align: center;
    }

    .btnclick {
      width: 161px;
      height: 57px;
      border-radius: 7px;
      border: 1px solid #ffffff;
      margin: 0 auto;
      margin-top: 82px;
      font-size: 24px;
      color: #ffffff;
      line-height: 57px;
      text-align: center;
      cursor: pointer;
    }
  }

  .partner {
    width: 100%;
    height: 376px;
    background: #ffffff;
    padding-top: 77px;

    h2 {
      font-size: 40px;
      font-weight: 500;
      color: #1d2754;
      line-height: 44px;
      text-align: center;
    }

    .partner__list {
      display: flex;
      width: 100%;
      height: 106px;
      margin-top: 68px;

      .parchild {
        flex: 1;

        .img1 {
          width: 249px;
          height: 70px;
          margin-top: 10px;
        }

        .img2 {
          width: 240px;
          height: 106px;
        }

        .img3 {
          width: 185px;
          height: 102px;
        }

        .img4 {
          width: 255px;
          height: 104px;
        }
      }
    }
  }
}

.warpDia {
  position: fixed;
  z-index: 100;
  top: 150px;
  left: calc(50% - 400px);
  width: 800px;
  height: 600px;

  .warpDia_one {
    border-radius: 25px 25px 0 0;
    /*height: 70px;*/
    background: #215fff;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .baei_img {
      margin-right: 25px;
      cursor: pointer;
      width: 30px;
      height: 30px;
      position: relative;
      bottom: -25px;
    }
  }

  .warpDia_two {
    height: 430px;
    background: #215fff;

    .baei_img_con {
      width: 100%;
      height: 100%;
    }
  }

  .warpDia_three {
    height: 100px;
    background: #215fff;
    display: flex;
    border-radius: 0 0 25px 25px;

    .warpDia_three_s {
      margin: auto;
      width: 250px;
      height: 70px;
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      p {
        position: absolute;
        left: 80px;
        top: 25px;
        font-size: 22px;
        color: #9e2b00;
        cursor: pointer;
      }
    }
  }
}

.mask {
  position: fixed;
  background: #000000;
  width: 100%;
  height: 2000px;
  top: 0px;
  left: 0px;
  opacity: 0.39;
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/index.vue